const styles = {
  root: {},

  title: {
    color: 'text.primary',
    '&.MuiTypography-h4': {
      color: 'text.primary',
    },
  },

  ratingContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },

  numberContainer: {
    width: 'auto',
  },

  linearProgressContainer: {
    width: '100%',
    paddingLeft: 1,
  },

  average: {
    fontSize: '40px!important',
    textAlign: 'center',
    fontWeight: 'bold',
  },

  number: {
    fontSize: '10px',
    lineHeight: '1.1',
  },

  linearProgress: {
    '&.MuiLinearProgress-root': {
      backgroundColor: '#e8eaed!important',
      borderRadius: 5,
      height: 10,
      '& .MuiLinearProgress-bar': {
        backgroundColor: '#e9b335!important',
      },
    },
  },

  totalReviews: {
    fontSize: '12px!important',
    lineHeight: '14px!important',
  },

  rating: {
    '&.MuiRating-root .MuiRating-iconFilled': {
      color: '#e9b335!important',
    },
  },

  addressContainer: {
    display: 'flex',
    alignItems: 'center!important',
    flexDirection: 'row',
    marginTop: 2,
  },

  addressIconContainer: {
    '& svg:first-of-type': {
      marginRight: 1,
    },
  },

  addressIcon: {
    '& svg': {
      fontSize: '30px',
    },
  },

  dFlex: {
    display: 'flex',
    alignItems: 'center',
  },

  borderTop: {
    border: '1px solid #e9e9e9',
    borderLeftWidth: 0,
    borderRightWidth: 0,
  },

  googleBusinessIcon: {
    '& svg': {
      fontSize: '30px',
    },
  },

  link: {
    textDecoration: 'none',
  },

  button: {
    padding: 1.5,
    fontSize: 12,
    margin: 0,
    backgroundColor: 'text.white',
    color: 'text.primaryDark',
    border: '1px solid rgba(0,0,0,0.2)',
    marginBottom: 0,
    '&:hover': {
      border: '1px solid rgba(0,0,0,0.2)',
    },
    '&.featured': {
      backgroundColor: '#8C46ED',
    },
    lineHeight: '18px !important',
  },

  footerTitle: {
    ml: 1,
    py: 2,
    width: '100%',
    '&.MuiTypography-caption': {
      fontWeight: 600,
      fontSize: 12,
      lineHeight: '14px',
      color: 'text.primaryDark',
    },
  },

}

export default styles
